import React, { useState } from 'react'
import { KonfhubButton } from '../../Atom/Buttons'
import DETCodeModals from './DETCodeModals'
import { getDETCodeAnalytics } from '../../../revampCRUD/Participants/DETCode.curd'
import { APIStatusCode } from '../../../services/util'
import { errorToaster } from '../../../reusable/common'

const DETCode = ({
    eventId,
    buttonText,
    btnType,
    showOverview,
    redirectToDETCodePage
}) => {
    const [screen, setScreen] = useState("UploadDETCodes")
    const [openDETModal, setOpenDETModal] = useState(false)
    const [DETAnalytics, setDETAnalytics] = useState({})
    const [loadModal, setLoadModal] = useState(false)

    const detCodeAnalytics = async () => {
        setLoadModal(true)
        try {
            const result = await getDETCodeAnalytics(eventId);
            if (result.status === APIStatusCode.STATUS_CODE_SUCCESS) {
                setDETAnalytics(result.data)
                setLoadModal(false)
            }
        } catch (err) {
            const errorMessage = err?.response?.data?.error ?? "Something went wrong";
            errorToaster(errorMessage);
            setLoadModal(false)
        }
    };



    return (
        <>
            <div className="pr-3">
                <KonfhubButton
                    btnType={btnType}
                    onClick={() => {
                        setOpenDETModal(true)
                        detCodeAnalytics()
                    }}>
                    {buttonText}
                </KonfhubButton>
            </div>
            <DETCodeModals
                openDETModal={openDETModal}
                setOpenDETModal={setOpenDETModal}
                DETAnalytics={DETAnalytics}
                eventId={eventId}
                loadModal={loadModal}
                setScreen={setScreen}
                screen={screen}
                showOverview={showOverview}
                redirectToDETCodePage={redirectToDETCodePage}
            />
        </>
    )
}

export default DETCode